<template>
    <PictureDetail></PictureDetail>
</template>
  
  <script>
  import PictureDetail from "@/components/PictureDetail";
  
  export default {
    name: "picture-index",
    components: {PictureDetail}
  }
  </script>
  
  <style scoped>
  
  </style>